import { CurrencyInterface } from "./CurrencyInterface";

import { EUR } from "./Currencies/EUR";

class CurrencyContainer {

  private currencies = [
    EUR
  ];

  private instances = [
    new EUR()
  ];

  public getCurrencies() {
    return this.currencies;
  }

  public getInstances(reorder: CurrencyInterface = null) {
    if (reorder === null) {
      return this.instances;
    }

    return [
      reorder,
      ...this.instances.filter(currency => currency.getCurrencyId() !== reorder.getCurrencyId())
    ];
  }

  public pickFromId(currencyId): CurrencyInterface {
    const index = this.getInstances().findIndex(currency => currency.getCurrencyId() === currencyId);
    return this.getInstances()[index];
  }

}

export default new CurrencyContainer();
